import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { dkeysInfoBaseURL } from "config/config";

// Асинхронный thunk для получения статьи МУ с боевого endpoint
export const fetchMPArticle = createAsyncThunk(
  "mpArticle/fetchMPArticle",
  async (codeMP, { rejectWithValue }) => {
    try {
      // Валидация code_mp
      const codeMPNum = parseInt(codeMP, 10);
      if (isNaN(codeMPNum) || codeMPNum <= 0) {
        return rejectWithValue("Некорректный code_mp. Ожидается положительное число.");
      }

      const response = await axios.get(`${dkeysInfoBaseURL}getArticleForMP`, {
        params: { code_mp: codeMPNum },
        responseType: "text",
      });

      // Endpoint возвращает либо строку HTML, либо объект с полем html
      const data = response.data;
      const html =
        typeof data === "string"
          ? data
          : typeof data?.html === "string"
          ? data.html
          : "";

      if (!html) {
        return rejectWithValue(`Статья МУ ${codeMPNum} не найдена`);
      }

      return html;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          return rejectWithValue(`Статья МУ ${codeMP} не найдена`);
        }
        return rejectWithValue("Сервер временно недоступен");
      }
      return rejectWithValue(error.message || "Ошибка загрузки статьи");
    }
  }
);

const mpArticleSlice = createSlice({
  name: "mpArticle",
  initialState: {
    html: null,
    codeMP: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearMPArticle: (state) => {
      state.html = null;
      state.codeMP = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMPArticle.pending, (state) => {
        state.loading = true;
        state.html = null;
        state.error = null;
      })
      .addCase(fetchMPArticle.fulfilled, (state, action) => {
        state.loading = false;
        state.html = action.payload;
        state.error = null;
      })
      .addCase(fetchMPArticle.rejected, (state, action) => {
        state.loading = false;
        state.html = null;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearMPArticle } = mpArticleSlice.actions;
export default mpArticleSlice.reducer;
